module.exports = __webpack_public_path__ + "static/media/relaxmit-4.33104c53.jpg";